var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 512 512",
    id: "Layer_1",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FDD267;}\n\t.st1{fill:#FFFFFF;}\n\t.st2{fill:#EDEDED;}\n\t.st3{fill:#FDDD8D;}\n\t.st4{fill:#FEE8B3;}\n\t.st5{fill:#F7B93C;}\n\t.st6{fill:#333333;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M501.1,222.2C491.8,229.5,260.7,411,256,414.7c3,2.3-40-31.5-245.1-192.5C11.3,221.8,246,7.6,245.5,8   c5.9-5.4,15-5.4,21,0C262.6,4.4,326.7,63,501.1,222.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M468.2,60.9V248l-192,150.8h-40.3L43.8,248V60.9c0-8.6,7-15.6,15.6-15.6h393.3   C461.2,45.3,468.2,52.3,468.2,60.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M468.2,60.9V248l-192,150.8h-40.3l-1.2-1L425.4,248V60.9c0-8.6-7-15.6-15.6-15.6h42.8   C461.2,45.3,468.2,52.3,468.2,60.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M501.1,222.2v262.2c0,6.5-2.6,12.4-6.9,16.7c-4.3,4.3-10.2,7-16.7,7h-443c-6.5,0-12.4-2.7-16.7-7   s-6.9-10.1-6.9-16.7V222.2l159.4,125.2l85.7,67.3l85.7-67.3L501.1,222.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M62.4,508.1H34.5c-6.5,0-12.4-2.7-16.7-7s-6.9-10.1-6.9-16.7V222.2l27.8,21.9v240.3c0,6.5,2.6,12.4,6.9,16.7   C49.9,505.4,55.8,508.1,62.4,508.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M501.1,222.2v262.2c0,6.5-2.6,12.4-6.9,16.7c-4.3,4.3-10.2,7-16.7,7h-42.8c6.5,0,12.5-2.7,16.7-7   c4.3-4.3,6.9-10.1,6.9-16.7V255.8L501.1,222.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M295.4,310.7h-78.7c-6.3,0-12.3,2.5-16.8,7c-66,66.5-181.6,183-182.1,183.5c4.3,4.3,10.2,7,16.7,7h443   c6.5,0,12.5-2.7,16.7-7c-108.2-109-93.2-94-182.1-183.4C307.7,313.2,301.7,310.7,295.4,310.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M225.9,317.6c-66,66.5-181.6,183-182.1,183.5c4.3,4.3,10.2,7,16.7,7h-26c-6.5,0-12.4-2.7-16.7-7   c0.5-0.5,116.1-116.9,182.1-183.5c4.5-4.5,10.5-7,16.8-7h26C236.4,310.7,230.4,313.2,225.9,317.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M494.2,501.1c-4.3,4.3-10.2,7-16.7,7h-42.8c6.5,0,12.5-2.7,16.7-7c-108.2-109-93.2-93.9-182-183.4   c-4.5-4.5-10.5-7-16.8-7h42.8c6.3,0,12.4,2.6,16.8,7C401,407.1,386,392.1,494.2,501.1z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M505,222.2c0-1.1-0.6-2.3-1.3-2.9l-31.6-28.9V60.9c0-10.8-8.7-19.5-19.5-19.5H308.9l-38-34.8    c-10.9-10-21.2-7.8-30.6,0.8l-37.1,33.9H59.4c-10.8,0-19.5,8.7-19.5,19.5v129.5c-19.1,17.4-31.5,28.8-31.6,28.9    c-0.7,0.6-1.3,1.9-1.3,2.9v262.2C7,499.8,19.5,512,34.5,512h443c15.2,0,27.6-12.4,27.6-27.6V222.2H505z M497.2,484.4    c0,3.9-1.1,7.6-3.2,10.8L347.6,347.8l149.6-117.4V484.4z M495,222c-4.4,3.5-12.4,9.8-22.9,18v-38.9L495,222z M248.2,10.9    c4.5-4.1,11.2-4.1,15.7,0L264,11c1.7,1.5,12.2,11.1,33.3,30.4h-82.5C234.8,23,248,11,248.2,10.9z M47.7,60.9    c0-6.4,5.2-11.6,11.6-11.6h393.3c6.4,0,11.6,5.2,11.6,11.6c0,25,0,185.8,0,185.3l-122.3,96l-27-27.2c-5.2-5.2-12.3-8.2-19.6-8.2    h-78.7c-7.4,0-14.3,2.9-19.6,8.1l-27,27.2l-122.3-96C47.7,246.1,47.7,60.9,47.7,60.9z M14.8,484.4V230.3l149.6,117.4L18.1,495.2    C16,492,14.8,488.3,14.8,484.4z M39.9,201.1V240L17,222C21.2,218.1,29.3,210.7,39.9,201.1z M34.5,504.1c-3.6,0-7.8-1.2-10.9-3.3    l179.1-180.4c3.7-3.7,8.7-5.8,14-5.8h78.7c5.2,0,10.3,2.1,14,5.8l179,180.4c-2.9,1.9-7.1,3.3-10.9,3.3H34.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M413.4,245.3c2.2,0,3.9-1.8,3.9-3.9c0-2.2-1.8-3.9-3.9-3.9H98.6c-2.2,0-3.9,1.8-3.9,3.9    c0,2.2,1.8,3.9,3.9,3.9H413.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M98.6,199.9h314.8c2.2,0,3.9-1.8,3.9-3.9c0-2.2-1.8-3.9-3.9-3.9H98.6c-2.2,0-3.9,1.8-3.9,3.9    C94.7,198.1,96.4,199.9,98.6,199.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M413.4,154.4c2.2,0,3.9-1.8,3.9-3.9c0-2.2-1.8-3.9-3.9-3.9H98.6c-2.2,0-3.9,1.8-3.9,3.9    c0,2.2,1.8,3.9,3.9,3.9H413.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M98.6,109h314.8c2.2,0,3.9-1.8,3.9-3.9c0-2.2-1.8-3.9-3.9-3.9H98.6c-2.2,0-3.9,1.8-3.9,3.9    C94.7,107.2,96.4,109,98.6,109z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.0f66d0b183aa1f078ae51d1624ed1a17.svg";
export { ForwardRef as ReactComponent };